export const MAX_IMPORT_PDF_FILE_BYTES = 20 * 1024 * 1024;
export const MAX_YJS_CONTENT_BYTES = 12 * 1024 * 1024;

export function uint8ArrayToBase64(bytes: Uint8Array): string {
  const chunkSize = 0x8000;
  let binary = '';
  for (let i = 0; i < bytes.length; i += chunkSize) {
    const chunk = bytes.subarray(i, i + chunkSize);
    binary += String.fromCharCode(...chunk);
  }
  return btoa(binary);
}

export function buildDocumentContentBody(content: Uint8Array): { contentBase64: string } {
  if (content.length > MAX_YJS_CONTENT_BYTES) {
    throw new Error('IMPORT_CONTENT_TOO_LARGE');
  }
  return { contentBase64: uint8ArrayToBase64(content) };
}
